var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAnnotationSidebarEmpty = function SvgAnnotationSidebarEmpty(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 65,
    fill: "none",
    viewBox: "0 0 64 65",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1977_5913)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.6,
    d: "M50.658 8.013a5.959 5.959 0 0 1 .999 11.831v18.923a12.7 12.7 0 0 0-2-.001V19.843a5.96 5.96 0 0 1-4.872-4.873h-25.44a5.96 5.96 0 0 1-4.875 4.874v25.437a5.96 5.96 0 0 1 4.875 4.876h18.922a12.6 12.6 0 0 0 0 2H19.344a5.959 5.959 0 1 1-6.874-6.875V19.844a5.96 5.96 0 0 1 1-11.831 5.96 5.96 0 0 1 5.874 4.957h25.441a5.96 5.96 0 0 1 5.873-4.957M13.471 47.197a3.959 3.959 0 1 0 .001 7.917 3.959 3.959 0 0 0-.001-7.917m0-37.184a3.959 3.959 0 1 0 .002 7.918 3.959 3.959 0 0 0-.002-7.918m37.187 0a3.959 3.959 0 1 0 .002 7.917 3.959 3.959 0 0 0-.002-7.917"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_1977_5913",
    width: 17,
    height: 17,
    x: 42.074,
    y: 42.564,
    fill: "#000",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42.074 42.564h17v17h-17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.74 50.355h-6.779v-6.791h-1.107v6.79h-6.78v1.108h6.78v6.79h1.107v-6.79h6.78z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.6,
    d: "M57.74 50.355h-6.779v-6.791h-1.107v6.79h-6.78v1.108h6.78v6.79h1.107v-6.79h6.78z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeOpacity: 0.6,
    strokeWidth: 0.9,
    d: "M57.74 50.355h-6.779v-6.791h-1.107v6.79h-6.78v1.108h6.78v6.79h1.107v-6.79h6.78z",
    mask: "url(#path-3-outside-1_1977_5913)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1977_5913"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h64v64H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAnnotationSidebarEmpty);
export default ForwardRef;